// extracted by mini-css-extract-plugin
export default {"wrapper":"jbByI","column":"j8wbm","singleBenefit":"ZfZr1","benefitsWrapper":"nDRi5","icon":"QpXoO","text":"amEDk","agreement":"njjzC"};